import chevronRightIcon from '../assets/images/chevron-right-gray.svg';
import chevronLeftIcon from '../assets/images/chevron-left-gray.svg';
import pageNumberIcon from "../assets/images/page-number-gray.svg";
import downArrowIcon from "../assets/images/down-arrow-gray.svg";
import React from "react";

export const PaginationComponent = ({pageInfo, onPageChange, onPageSizeChange, title}) => {
    const totalPages = pageInfo.totalPages;
    const currentPage = pageInfo.pageIndex;

    const pageSizeOptions = [10, 25, 50, 100];

    const getPageNumbers = () => {
        const pages = [];
        const showMax = 5;

        if (totalPages <= showMax) {
            for (let i = 0; i < totalPages; i++) {
                pages.push(i);
            }
        } else {
            pages.push(0);

            let startPage = Math.max(currentPage - 1, 1);
            let endPage = Math.min(currentPage + 1, totalPages - 2);

            if (startPage > 1) {
                pages.push('...');
            }

            // Add middle pages
            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }

            if (endPage < totalPages - 2) {
                pages.push('...');
            }

            pages.push(totalPages - 1);
        }

        return pages;
    };

    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value);
        onPageSizeChange(newPageSize);
    };

    return (
        <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
            <div className="flex flex-1 justify-between sm:hidden">
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 0}
                    className={`relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium ${
                        currentPage === 0
                            ? 'text-gray-300'
                            : 'text-gray-700 hover:bg-gray-50'
                    }`}
                >
                    Previous
                </button>
                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages - 1}
                    className={`relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium ${
                        currentPage === totalPages - 1
                            ? 'text-gray-300'
                            : 'text-gray-700 hover:bg-gray-50'
                    }`}
                >
                    Next
                </button>
            </div>
            <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                <div className="flex items-baseline">
                    <p className="text-sm text-gray-700">
                        Showing{' '}
                        <span className="font-medium">
                            {pageInfo.pageIndex * pageInfo.pageSize + 1}
                        </span>{' '}
                        to{' '}
                        <span className="font-medium">
                            {Math.min((pageInfo.pageIndex + 1) * pageInfo.pageSize, pageInfo.totalCount)}
                        </span>{' '}
                        of{' '}
                        <span className="font-medium">{pageInfo.totalCount}</span>{' '}
                        {title}
                    </p>
                    <div className="relative ml-4">
                        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                            <img src={pageNumberIcon} className="h-5 w-5" alt=""/>
                        </div>

                        <select
                            value={pageInfo.pageSize}
                            onChange={handlePageSizeChange}
                            className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white text-gray-700
                        appearance-none cursor-pointer hover:border-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
                        sm:text-sm transition-colors duration-200"
                        >
                            {pageSizeOptions.map(size => (
                                <option key={size} value={size}>
                                    Show {size}
                                </option>
                            ))}
                        </select>

                        <div
                            className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400">
                            <img src={downArrowIcon} className="h-5 w-5" alt=""/>
                        </div>
                    </div>
                </div>
                <div>
                    <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="PaginationComponent">
                        <button
                            onClick={() => onPageChange(currentPage - 1)}
                            disabled={currentPage === 0}
                            className={`relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 ${
                                currentPage === 0
                                    ? 'cursor-not-allowed'
                                    : 'hover:bg-gray-50'
                            }`}
                        >
                            <span className="sr-only">Previous</span>
                            <img src={chevronLeftIcon} className="h-5 w-5" alt=""/>
                        </button>

                        {getPageNumbers().map((pageNum, index) => (
                            pageNum === '...' ? (
                                <span
                                    key={`ellipsis-${index}`}
                                    className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300"
                                >
                                    ...
                                </span>
                            ) : (
                                <button
                                    key={pageNum}
                                    onClick={() => onPageChange(pageNum)}
                                    className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${
                                        currentPage === pageNum
                                            ? 'z-10 bg-indigo-600 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                                            : 'text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50'
                                    }`}
                                >
                                    {pageNum + 1}
                                </button>
                            )
                        ))}

                        <button
                            onClick={() => onPageChange(currentPage + 1)}
                            disabled={currentPage === totalPages - 1}
                            className={`relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 ${
                                currentPage === totalPages - 1
                                    ? 'cursor-not-allowed'
                                    : 'hover:bg-gray-50'
                            }`}
                        >
                            <span className="sr-only">Next</span>
                            <img src={chevronRightIcon} className="h-5 w-5" alt=""/>
                        </button>
                    </nav>
                </div>
            </div>
        </div>
    );
};